import { render, staticRenderFns } from "./wait.vue?vue&type=template&id=ba8196a4&scoped=true"
import script from "./wait.vue?vue&type=script&lang=js"
export * from "./wait.vue?vue&type=script&lang=js"
import style0 from "./wait.vue?vue&type=style&index=0&id=ba8196a4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8196a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba8196a4')) {
      api.createRecord('ba8196a4', component.options)
    } else {
      api.reload('ba8196a4', component.options)
    }
    module.hot.accept("./wait.vue?vue&type=template&id=ba8196a4&scoped=true", function () {
      api.rerender('ba8196a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/flowinstances/wait.vue"
export default component.exports